import React from 'react'
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom'
import { Box, Card, Typography, Divider, Link, Skeleton, Icon, useMediaQuery } from '@mui/material'
import { useQuery } from 'react-query'
import { useTheme } from '@mui/material/styles'

// Local Import

// API service
import { getLeavePolicies } from 'services/api/modules/leave/leavePolicy'
import AdxButton from 'components/custom/AdxButton'

const LeaveDetailsImport = ({ sx, ...rest }) => {
  let location = useLocation()
  const navigate = useNavigate()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('sm'))

  //CALLING API
  const { data, isLoading } = useQuery('leave-policy', async () => {
    const { data: apiData } = await getLeavePolicies()
    return apiData.data
  })

  let skeletonArray = new Array(1).fill('i')

  // Leave Allocation Import
  const importLeaveDetails = () => {
    navigate('/app/management-centre/company-management/leave/leave-details/', {
      state: {
        backgroundLocation: location,
      },
    })
  }

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          boxSizing: 'border-box',
          borderRadius: '4.5px',
        }}
      >
        <Box display={'flex'} flexDirection={'column'}>
          {isLoading ? (
            skeletonArray.map((arr, index) => (
              <React.Fragment key={index}>
                <Box
                  sx={{
                    display: { xs: 'column', sm: 'flex' },
                    justifyContent: 'space-between',
                  }}
                >
                  <Box p={{ xs: 1, sm: 2 }} width={{ xs: 1, sm: 1 / 3 }}>
                    <Skeleton width={'100%'} height={35} />
                  </Box>
                  <Box p={{ xs: 1, sm: 2 }} width={{ xs: 1, sm: 1 / 4 }}>
                    <Skeleton width={'100%'} height={35} />
                  </Box>
                </Box>
                <Divider light />
              </React.Fragment>
            ))
          ) : (
            <>
              <Box
                sx={{
                  width: '100%',
                  p: 2,
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },

                  alignItems: { xs: 'flex-start', sm: 'center' },
                  boxSizing: 'border-box',
                }}
              >
                <Box
                  mb={1}
                  display={'flex'}
                  flexDirection={{ xs: 'column', sm: 'row' }}
                  rowGap={1}
                  alignItems={'center'}
                  sx={{
                    width: 1,
                    justifyContent: 'space-between',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',

                      width: { xs: 1, sm: 3 / 4 },
                      alignItems: 'center',
                    }}
                  >
                    {matches ? (
                      <Box
                        sx={{
                          mr: 2,
                          height: 45,
                          minWidth: 45,
                          backgroundColor: 'alternate.light',
                          borderRadius: '50%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <Icon sx={{ fontSize: 25, color: 'alternate.main' }}>summarize</Icon>
                      </Box>
                    ) : null}

                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <Typography variant="subtitle1">Staff Leave Details</Typography>
                      <Typography variant="subtitle1" color="light-gray-text.main">
                        Download the Excel file to get started with employee details required for
                        importing leave data
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      width: { xs: 1, sm: 1 / 4 },
                      display: 'flex',
                      justifyContent: { xs: 'center', sm: 'flex-end' },
                    }}
                  >
                    <AdxButton sx={{ width: '80%' }} onClick={importLeaveDetails}>
                      Import
                    </AdxButton>
                  </Box>
                </Box>
              </Box>
            </>
          )}
        </Box>
      </Card>
    </>
  )
}

export default LeaveDetailsImport
